import { Switch } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { purchasePage, stockPage, updateStatus } from "../../../API";
import Pagination from "../../../components/Pagination";
import { showLoding } from "../../../utils/tool";
import { useNavigate } from "react-router";


interface HomeProps {
  onRestock: any,
}
const ComponentName: React.FC<HomeProps> = ({
  onRestock,
}) => {
  const { t } = useTranslation();

  const [pageSize, setPageSize] = React.useState(20)
  const [totalPages, setTotalPages] = React.useState(0)
  const [productList, setProductList] = React.useState<any>([])
  const [pageIndex, setPageIndex] = React.useState(1)
  useEffect(() => {
    handlePurchasePage()
  }, [pageIndex])
  const handlePurchasePage = () => {
    stockPage({
      "pageNum": pageIndex,
      "pageSize": pageSize,
    }).then((res) => {
      setProductList(res.data.records)
      setTotalPages(res.data.total)
    }).catch((err) => {
      console.log(err)
    })
  }

  const handleUpdateStatus = (id: string, enable: boolean) => {
    showLoding(true)
    updateStatus({
      id: id,
      enable
    }).then((res) => {
      handlePurchasePage()
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }
  const navigate = useNavigate()

  return (
    <div className="">
      {
        productList && productList.map((item: any, index: React.Key | null | undefined) => (
          <div className="flex mb-10 pb-10 cursor-pointer" key={index}
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, .2)"
            }}>
            <img src={item?.imageUrl}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/product?id=${item?.productId}&category=${'精選商品'}`)
              }}
              className="w-[100px] h-[100px] rounded-[10px] mr-[15px] object-cover"
              alt="" />
            <div className="flex-1">
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/product?id=${item?.productId}&category=${'精選商品'}`)
                }}>
                <div className="text-[16px] text-[#181512] font-bold  line-clamp-1">{item?.title}</div>
                <div className="text-[14px] text-[#595959] ">進貨價：US$ {item?.originalPrice}</div>
                <div className="text-[14px] text-[#595959] ">庫存：{item?.stockQuantity}</div>
              </div>
              <div className="flex items-center">
                <div className="flex-1">
                  <Switch
                    value={item.enable}
                    onChange={() => { 
                      handleUpdateStatus(item.id, !item.enable)
                    }}
                  />
                </div>
                <div className="bg-[#000] rounded-[4px] inline-block px-[20px] py-[6px] text-[#fff] text-[14px] cursor-pointer"
                  onClick={() => {
                    onRestock(item)
                  }}
                >
                  補貨
                </div>
              </div>
            </div>
          </div>
        ))
      }
      <div className="flex justify-center pb-[30px] pt-20">
        {
          Math.ceil(totalPages / pageSize) > 1 ?
            <Pagination
              totalPages={Math.ceil(totalPages / pageSize)}
              currentPage={pageIndex}
              onPageChange={(page: number) => setPageIndex(page)}
            /> : ''
        }
      </div>
    </div>
  );
};

export default ComponentName;
